export default __webpack_public_path__ + "static/media/DYMO_Logo_2018_Blue (1).f6a0c62e.jpg";